export interface Story {
  slug: string;
  title: string;
  label: string;
  summary: string;
  steps: { title: string; body: string }[];
}

/** Operational walkthroughs — not named customers or testimonials. */
export const STORIES: Story[] = [
  {
    slug: 'retail-counter',
    title: 'A retail counter that stays balanced',
    label: 'General retail',
    summary: 'Open POS, sell mixed payments, and close with a count that matches expected cash.',
    steps: [
      {
        title: 'Open',
        body: 'The cashier declares opening cash. The register stays blocked until the float is set.',
      },
      {
        title: 'Sell',
        body: 'Products come from the same catalogue the Business app maintains. Cash, card, and transfer are recorded as method labels and amounts — not card numbers.',
      },
      {
        title: 'Close',
        body: 'Counted cash versus expected cash posts a short or over. Managers review sessions in Business.',
      },
    ],
  },
  {
    slug: 'stock-led-shop',
    title: 'A shop that cannot sell what it does not have',
    label: 'Inventory',
    summary: 'Every plan tracks cost, levels, and movements. A sale reduces stock without a spreadsheet.',
    steps: [
      {
        title: 'Catalogue',
        body: 'Add products with name and price in Business. They appear on POS immediately.',
      },
      {
        title: 'Stock',
        body: 'Receive and adjust in Inventory. Cost of goods posts when a tracked item sells.',
      },
      {
        title: 'Attention',
        body: 'Low stock is a Business problem, not a WhatsApp guess. POS already deducted the unit.',
      },
    ],
  },
  {
    slug: 'several-registers',
    title: 'Several cashiers, one set of books',
    label: 'Growing operations',
    summary: 'Each cashier has a session. Owners see the branch without reconstructing every drawer.',
    steps: [
      {
        title: 'Roles',
        body: 'Cashiers sell. Managers void, refund, and review. Owners see organisation-wide money.',
      },
      {
        title: 'Accountability',
        body: 'Sales and POS gaps are attributed to the session that created them.',
      },
      {
        title: 'Locations',
        body: 'Growth covers up to five branches. Enterprise is arranged with sales when you need more.',
      },
    ],
  },
];

export function getStory(slug: string) {
  return STORIES.find((story) => story.slug === slug);
}
